import React from 'react'

export default function SeoSix() {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2.1826 8C1.65594 7.36667 1.33594 6.55333 1.33594 5.66667C1.33594 3.65333 2.9826 2 5.0026 2H8.33594C10.3493 2 12.0026 3.65333 12.0026 5.66667C12.0026 7.68 10.3559 9.33333 8.33594 9.33333H6.66927'
        stroke='#5E6278'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M13.82 8.00008C14.3467 8.63341 14.6667 9.44675 14.6667 10.3334C14.6667 12.3467 13.02 14.0001 11 14.0001H7.66667C5.65333 14.0001 4 12.3467 4 10.3334C4 8.32008 5.64667 6.66675 7.66667 6.66675H9.33333'
        stroke='#5E6278'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  )
}
